/**
 * Booking panel features that are built in stages. A feature that is off
 * here stays off whatever the account settings say.
 *
 * - dedicatedOrders: on. The Dedicated tab (P4 pilot) shows only when GET
 *   account/settings also says dedicated_orders: true, which staff turn on
 *   per company, so nothing changes for anyone else. Its Details step asks
 *   for a pickup 2 hours to 30 days ahead. Needs orders-service that accepts
 *   order_type 'dedicated'; an older one refuses it (dedicated_not_enabled),
 *   which the Details step shows.
 * - loaders: on. The question still shows only for a quote that offers
 *   loaders (pricing: medium and large vehicles once ops sets a rate), so
 *   nothing appears until a rate exists. Needs orders-service with loaders
 *   (an older one ignores loaders_count and would not charge them).
 * - preferredDriver: on. "Have a driver in mind?" on the Details step (the
 *   PreferredDriverField). Needs orders-service with POST
 *   preferred_driver/lookup; an older one fails the lookup, which the field
 *   shows as "Can't check right now", and ignores preferred_driver on
 *   createOrder, so the order still goes through.
 */
export const ORDER_FEATURES = {
  dedicatedOrders: true,
  loaders: true,
  preferredDriver: true,
} as const;

export type OrderType = "on_demand" | "dedicated";
